export var gtmCallback = function gtmCallback(element, gtm) {
  if (element && gtm === 'GTM-NSW8N73') {
    window.open(element.href, element.target ? element.target : '_self');
  }
};
export var isDataLayer = function isDataLayer() {
  return window.DGS && window.DGS.GTMTracking && window.DGS.GTMTracking.getDataLayer().length;
};
export var sendCustomEvent = function sendCustomEvent(eventCategory, eventAction, eventLabel, element) {
  return {
    event: 'GAevent',
    eventCategory: eventCategory,
    eventAction: eventAction,
    eventLabel: eventLabel,
    eventCallback: function eventCallback(gtm) {
      gtmCallback(element, gtm);
      setTimeout(function () {
        window.open(element.href, element.target ? element.target : '_self');
      }, 4000);
    }
  };
};
export var sendDataLayerMoreEvent = function sendDataLayerMoreEvent(category, action, label, element) {
  if (isDataLayer()) {
    if (element) {
      element.preventDefault();
    }
    window.DGS.GTMTracking.getDataLayer().push(sendCustomEvent(category, action, label, element && element.currentTarget ? element.currentTarget : null));
  }
};